<div class="row">
  <div class="col s12">
    <lms-dynamic-form
      [questions]="questions"
      [action]="'clients.sftp'"
      [options]="{ disableCard: true }"
      (submit)="submit($event)"
    ></lms-dynamic-form>
  </div>
</div>
